import { useTranslation } from 'react-i18next';
import {
  NotificationModel,
  NotificationType,
  useGetNotificationsQuery,
} from '@customer/store/apis/notificationsApi';
import { useTableData } from '@customer/shared/hooks/useTableData';
import { NoResults } from '@dmc/ui';
import AccordionNotificationReleaseNote from '@customer/components/accordions/notifications/release-note/AccordionNotificationReleaseNote';
import AccordionNotificationTechBulletin from '@customer/components/accordions/notifications/tech-bulletin/AccordionNotificationTechBulletin';
import useControlledAccordions, {
  ControlledAccordion,
} from '@customer/components/accordions/useControlledAccordions';

export function NewNotifications() {
  const { t } = useTranslation();

  const noResultsDescription = t('NoNewNotifications');

  const { data, ...requestRemainder } = useGetNotificationsQuery(undefined, {
    refetchOnMountOrArgChange: 600,
  });

  const { hasData, noDataDescription } = useTableData<NotificationModel>({
    data: data?.notifications,
    ...requestRemainder,
    noResultsDescription,
  });

  const { getControlledProps } = useControlledAccordions(data?.notifications?.[0]?.id);

  if (data?.notifications && hasData) {
    return (
      <>
        {data.notifications.map((notification: NotificationModel) => {
          const key = notification.id;
          const controlled: ControlledAccordion = getControlledProps(key);

          switch (notification.type) {
            case NotificationType.ReleaseNote: {
              return (
                <AccordionNotificationReleaseNote
                  key={key}
                  controlled={controlled}
                  {...notification}
                />
              );
            }
            case NotificationType.TechBulletin: {
              return (
                <AccordionNotificationTechBulletin
                  key={key}
                  controlled={controlled}
                  {...notification}
                />
              );
            }
            default:
              return null;
          }
        })}
      </>
    );
  } else {
    return <NoResults description={noDataDescription} />;
  }
}

export default NewNotifications;
